import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { MmaoReject } from '@app/store';

/**
 * When seller reject an offer
 */
const events = getEvents((action: MmaoReject) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'mmaoReject',
      buy_or_sell: action.payload.userRole,
      product_brand: action.payload.product.brand.name,
      product_univers: action.payload.product.universe.name,
      product_category: action.payload.product.category.name
    }
  }
]);

export default events;
